import { get } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { Col, Container, Row } from "reactstrap";

import CollapsibleCard from "src/components/CollapsibleCard/CollapsibleCard";
import { IconName } from "src/components/Icon/Icon";
import * as S from "../../../../constants/StringConstants";
import { IRootState } from "../../../../store/reducers";

interface RouteParams {
  id: string;
}

const QuestionAnswersStatusTracker: React.FC = () => {
  const { id: proposalIDParam } = useParams<RouteParams>();
  const proposalID = proposalIDParam || "new";
  const questionAnswersStatus = useSelector((state: IRootState) => state.questionAnswersStatus);
  const questionsAnswersTracker = get(questionAnswersStatus.map, proposalID, []);

  return (
    <CollapsibleCard title={S.PD_QA_HEADER} iconName={IconName.ProposalBuilderQaTracker} defaultOpen={true}>
      <Container>
        <div className="card-file-list-container">
          {questionsAnswersTracker.length > 0 ? (
            questionsAnswersTracker.map(qa => (
              <Row key={qa.id} className="card-row qa-row">
                <Col>{qa.qaLabel}</Col>
                <Col>{qa.timeLabel}</Col>
                <Col>{qa.dateLabel}</Col>
              </Row>
            ))
          ) : (
            <Row className="card-row">
              <Col>{S.PD_QA_NO_DATA_AVAILABLE}</Col>
            </Row>
          )}
        </div>
      </Container>
    </CollapsibleCard>
  );
};

export default QuestionAnswersStatusTracker;
